import { ApprovalTypes } from 'ui-product-approvals-common';
import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
import { useHasQuotesTeamBeta } from './useHasQuotesTeamBeta';
export const useHasSeqReqChangesRedesign = approvalType => {
  const getIsUngated = useGetIsUngated();
  // Quotes needs the redesign for their team-based-approvals beta, so the
  // commerce:qmgmt:TeamBasedApprovals gate opts Quote approvals into it as well.
  const hasQuotesTeamBeta = useHasQuotesTeamBeta();
  return getIsUngated(GATES.CHANGES_REQUESTED_AND_STAGES) || getIsUngated(GATES.AGENT_APPROVER) || hasQuotesTeamBeta && approvalType === ApprovalTypes.QUOTE;
};